const ToolsEndpoints = {
  compress: {
    method: 'POST',
    url: () => `/tool/compress`,
  },
} as const;

// Create type from the object
type ToolsEndpoints = typeof ToolsEndpoints;

export type { ToolsEndpoints };
export default ToolsEndpoints;
